import { useQuery } from '@tanstack/react-query';
import { getAssetsExchangeRates } from '../requests';

type Options = {
  refetchInterval?: number;
};

const useAssetsExchangeRates = (
  assetCodeToPay: string,
  assetCodeToReceive: string,
  enabled = true,
  { refetchInterval }: Options = {}
) => {
  const { data, isLoading, isFetching, isError, error } = useQuery({
    queryKey: ['assets-exchange-rates', assetCodeToPay, assetCodeToReceive],
    queryFn: () =>
      getAssetsExchangeRates({ assetCodeToPay, assetCodeToReceive }),
    enabled: enabled && !!assetCodeToPay && !!assetCodeToReceive,
    refetchInterval,
    refetchIntervalInBackground: false,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    error,
  };
};

export { useAssetsExchangeRates };
